import { useCallback, useState } from 'react';

export const useMobileNavOpen = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const openMobileNav = useCallback(() => setMobileNavOpen(true), []);
  const closeMobileNav = useCallback(() => setMobileNavOpen(false), []);

  return { mobileNavOpen, openMobileNav, closeMobileNav };
};
